var $e6b5fb5e7ecde168$exports = {};
$e6b5fb5e7ecde168$exports = {
    "backButton": (args)=>`Geri d\xf6n: ${args.prevMenuButton}`,
    "moreActions": `Daha fazla eylem`,
    "unavailable": `Kullan\u{131}lam\u{131}yor, ayr\u{131}nt\u{131}lar\u{131} g\xf6rmek i\xe7in geni\u{15F}letin`
};


export {$e6b5fb5e7ecde168$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
